import { render, staticRenderFns } from "./hazardDepartConfig.vue?vue&type=template&id=bb7fc1ec&scoped=true&"
import script from "./hazardDepartConfig.vue?vue&type=script&lang=ts&"
export * from "./hazardDepartConfig.vue?vue&type=script&lang=ts&"
import style0 from "./hazardDepartConfig.vue?vue&type=style&index=0&id=bb7fc1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7fc1ec",
  null
  
)

export default component.exports